import { render, staticRenderFns } from "./UndoSnackbar.vue?vue&type=template&id=452db528&scoped=true&lang=pug&"
import script from "./UndoSnackbar.vue?vue&type=script&lang=js&"
export * from "./UndoSnackbar.vue?vue&type=script&lang=js&"
import style0 from "./UndoSnackbar.vue?vue&type=style&index=0&id=452db528&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452db528",
  null
  
)

export default component.exports